import { makeAutoObservable } from "mobx"
import { getStockDetailData, getStockDetailDataSSE } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType, QuoteTradeRecord } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.沪深A股) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null

  QuoteTradeType = QuoteTradeRecord.未知
  

  init() {
    this.getData()
  }

  getData() {
    getStockDetailDataSSE(window.quotedata.quotecode, "f43,f44,f45,f46,f47,f48,f49,f50,f51,f52,f55,f57,f59,f60,f62,f71,f84,f85,f92,f107,f111,f116,f117,f122,f127,f135,f136,f137,f138,f139,f140,f141,f142,f143,f144,f145,f146,f147,f148,f149,f152,f161,f162,f163,f164,f165,f167,f168,f169,f170,f171,f173,f177,f178,f181,f182,f191,f198,f251,f252,f254,f256,f257,f255,f260,f261,f262,f264,f265,f266,f267,f268,f269,f270,f272,f274,f275,f276,f277,f278,f279,f288,f290,f292,f293,f294,f295,f301,f531,f734,f743,f744,f746,f747,f748,f750", (data:any)=>{
      this.setStockDetail(data)
    })
  }

  setStockDetail(StockDetail: any) {
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }

  setQuoteTradeType(QuoteTradeType: any) {
    this.QuoteTradeType = QuoteTradeType
  }
}

export const store = new Store()
